import { Table } from "flowbite-react";
import { useEffect, useState } from "react";
import { userService } from "../../../services/user-service";
import { PartnerMonthlyStatisticsDto } from "../../../types/dto/partner-monthly-statistics-dto";
import { Body14Regular } from "../../typography/Body14Regular";
import { CustomCell } from "../CustomCell";
import { Row } from "./Row";

interface Props {}

const headers = ["총 가입 파트너", "발주 진행 파트너 (이번 달)"];

export const PartnerStatisticsTable: React.FC<Props> = ({}) => {
  const data = {
    totalCount: 0,
    currentMonthOrderPartner: 0,
  };

  const [statistics, setStatistics] = useState<PartnerMonthlyStatisticsDto>({
    numPartnerInMonth: 0,
    numPartnerOrderedInMonth: 0,
    numPartnerTotal: 0,
  });

  const getStatistics = async () => {
    try {
      const response = await userService.getPartnerMonthlyStatistics();
      console.log("1", response.data);
      setStatistics(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getStatistics();
  }, []);

  return (
    <div className="overflow-x-auto rounded-lg border border-semantic-divider">
      <Table>
        <Table.Head>
          {headers.map((title, index) => (
            <Table.HeadCell
              className={`w-[824px] h-[52px] p-0 border-b ${
                index === 1 ? "border-l" : ""
              } border-semantic-divider `}
              key={title}
            >
              <CustomCell>
                <Body14Regular>{title}</Body14Regular>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          <Row data={statistics} />
        </Table.Body>
      </Table>
    </div>
  );
};
